import { Helmet } from "react-helmet-async";

const SITE = "https://mortgagepath.uk";

/**
 * Per-page SEO helper.
 * Renders <title>, meta description, canonical link, and Open Graph + Twitter cards.
 * Each page can pass a `path` (e.g. "/calculator") used to build the canonical URL.
 */
const Seo = ({
  title,
  description,
  path = "/",
  type = "website",
  noindex = false,
}) => {
  const fullTitle = title.includes("MortgagePath") ? title : `${title} | MortgagePath`;
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="MortgagePath" />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
